<template>
  <v-data-table-server
    :items-per-page="existing.perPage"
    :headers="localDataTable.headers"
    :items="localDataTable.items"
    :loading="existing.loading"
    :items-length="existing.totalItems"
    :page="existing.page"
    @update:options="fetchData"
  >
    <template v-slot:item="{ item, index }">
      <tr
        class="border-gray-950 h-14 align-top"
        :class="{
          'bg-gray-50': getIndex(index).displayIndex % 2 === 0,
        }"
      >
        <td class="pt-5 font-medium">
          <h6 class="ml-2">
            {{ getIndex(index).displayIndex }}
          </h6>
        </td>
        <td class="py-2">
          <v-text-field
            :key="item.uuid"
            variant="outlined"
            density="compact"
            placeholder="Nama renewable energy"
            class="w-full"
            v-model="item.name"
            :id="'name_' + item.uuid + '_' + getIndex(index).displayIndex"
            :rules="formValidasi.name"
            autocomplete="off"
            @input="item.is_touched = true"
            @blur="item.name_touched = true"
            :error="hasErrors(item, 'name')"
            :error-messages="
              existing.items.find((data) => data.uuid === item.uuid)?.duplicate
                ? 'Renewable energy tidak boleh sama.'
                : getErrors(item, 'name')
            "
            hide-details="auto"
            v-if="isEdit"
          ></v-text-field>
          <h6 v-else class="font-medium mt-3">
            {{ item.name }}
          </h6>
        </td>
        <td class="py-2">
          <div class="w-fit mt-2">
            <label
              class="flex items-center select-none gap-2"
              :class="{ 'cursor-pointer': isEdit }"
            >
              <div class="relative">
                <input
                  type="checkbox"
                  class="sr-only"
                  v-model="item.active"
                  :disabled="!isEdit"
                  @update:model-value="item.is_touched = true"
                />
                <div
                  :class="{
                    'bg-green-600': item.active,
                    'bg-slate-600': !item.active,
                  }"
                  class="block h-6 rounded-full w-11"
                ></div>
                <div
                  :class="{
                    'translate-x-full': item.active,
                  }"
                  class="absolute flex items-center justify-center w-5 h-5 transition bg-white rounded-full left-[2px] top-[2px]"
                ></div>
              </div>
              <span class="text-xs font-medium">
                {{ item.active ? "Active" : "Inactive" }}
              </span>
            </label>
          </div>
        </td>
        <td class="py-2">
          <v-text-field
            :key="item.uuid"
            variant="outlined"
            density="compact"
            placeholder="Konversi PLN"
            class="w-full"
            v-model="item.konversi_pln"
            :id="
              'konversi_pln_' + item.uuid + '_' + getIndex(index).displayIndex
            "
            :rules="formValidasi.konversi_pln"
            autocomplete="off"
            @input="handleInput($event, index)"
            @blur="item.konversi_pln_touched = true"
            :error="hasErrors(item, 'konversi_pln')"
            :error-messages="getErrors(item, 'konversi_pln')"
            hide-details="auto"
            v-if="isEdit"
          ></v-text-field>
          <h6 v-else class="font-medium mt-3">
            {{ item.konversi_pln }}
          </h6>
        </td>
        <td class="text-center pt-4">
          <img
            src="../../../../assets/icon/trash.png"
            alt="icon"
            loading="lazy"
            class="min-w-6 w-6 cursor-pointer h-auto"
            @click="removeRow(item.existing_index)"
            :id="'remove_' + getIndex(index)?.displayIndex"
          />
        </td>
      </tr>
    </template>
  </v-data-table-server>
</template>

<script>
export default {
  name: "RenewableEnergyTableComponent",
  props: {
    dataTable: Object,
    existing: Object,
    formValidasi: Object,
    isEdit: Boolean,
    addRow: Function,
    handleInput: Function,
    removeRow: Function,
    fetchData: Function,
  },
  computed: {
    localDataTable: {
      get() {
        return this.dataTable;
      },
      set(newValue) {
        this.$emit("update:dataTable", newValue); // Kirim event ke parent
      },
    },
    indexedData() {
      let counter = 1;
      let startIndex = this.dataTable.start_index ?? 0;
      return this.dataTable.items.map((dt, index) => {
        if (!dt.deleted) {
          return {
            ...dt,
            displayIndex: startIndex + counter++,
            realIndex: index,
          };
        } else {
          return { ...dt, displayIndex: null, realIndex: index };
        }
      });
    },
  },
  methods: {
    getIndex(index) {
      return this.indexedData.find((item) => item.realIndex === index);
    },
    hasErrors(data, touched) {
      return this.getErrors(data, touched).length > 0;
    },
    getErrors(value, touched) {
      if (!value[`${touched}_touched`]) return [];
      const rules = this.formValidasi[touched];
      const errors = rules
        .map((rule) => rule(value[touched]))
        .filter((result) => result !== true);
      return errors;
    },
  },
};
</script>
